import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

export const SaveButtonDiv = styled.div`
    display: flex;
    width: 100;
    padding-left: 34;
`;

export const ButtonWrapper = styled.div`
    display: flex;
    justify-content: flex-end;
`;

export const ModalBackground = styled.div`
    background-color: white;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    height: 221px;
    justify-content: space-between;
    padding: 40px;
    position: absolute;
    width: 430px;
    -webkit-box-shadow: 0px 1px 2px 0px rgb(204, 204, 204);
    -moz-box-shadow: 0px 1px 2px 0px rgb(204, 204, 204);
    box-shadow: 0px 1px 2px 0px rgb(204, 204, 204);
`;

export const Background = styled.div`
    align-items: center;
    background-color: rgba(0,0,0,0.8);
    bottom: 0px;
    display: flex;
    justify-content: center;
    left: 0px;
    position: fixed;
    right: 0px;
    top: 0px;
    z-index: 10;
`;

export const TopNavDiv = styled.div`
    display: flex;
    flex-flow: row;
    z-index: 2;
    position: relative;
    height: 100%;
    flex-grow: 1;
    width: 100px;
    font-size: 20px;
    padding-left: 35px;
`;

export const ButtonDiv = styled.div`
    display: inline-block;
    width: 30px;
    height: 30px;
    padding: 10px 5px;
`;

export const VersionHistoryHeader = styled.p`
    color: #000;
    font-size: 20px;
    font-weight: 600;
    line-height: 32px;
    text-align: left;
    margin: auto 26px;
`;

export const LastSavedDiv = styled.div`
    padding: 8px 0;
`;

export const LastSavedText = styled.a`
    color: ${({ isVersionHistoryItemSaving, theme }) => (isVersionHistoryItemSaving ? theme.colors.primary300 : '#444')};
    font-size: 13px;
    font-weight: 400;
    text-align: left;
    text-decoration: ${({ isVersionHistoryItemSaving }) => (isVersionHistoryItemSaving ? 'none' : 'underline')};
    cursor: ${({ isClickable }) => (isClickable ? 'pointer' : 'default')};
    padding: 4px;
    line-height: 32px;

    &:hover {
        color: ${({ isClickable, isVersionHistoryItemSaving, theme }) => ((isClickable || isVersionHistoryItemSaving) ? theme.colors.primary300 : '#444')};
    }
`;

export const DisabledLastSavedText = styled(LastSavedText)`
    color: ${({ theme }) => theme.colors.neutral200};
    text-decoration: none;
    cursor: not-allowed;
    &:hover {
        color: ${({ theme }) => theme.colors.neutral200};
    }
`;

export const SaveTooltipText = styled.span`
    font-weight: 600;
`;

export const ConnectionErrorIcon = styled(FontAwesomeIcon)`
    position: relative;
    bottom: 45px;
    left: 18px;
    font-size: 13px;
`;
